import { Component } from 'react';
import Loader from '../../../../../utils/Loader';
import { ToastContainer } from 'react-toastify';
import { withRouter } from '../../../../../utils/withRouter';
import { connect } from 'react-redux';
import {
    insertUpdatePRAgencyMaster_action,
} from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/pr_agency_master_action';
import { toastError, toastSuccess } from '../../../../../utils/constants';
import { emailValidator } from '../../../../../utils/Validator';
import HeaderWithLogo from '../../../../../common_components/header_with_logo';
import AdminDrawer from '../../../../../common_components/admin_module_drawer';
import Footer from '../../../../../common_components/Footer';

class PRAgencyMasterAU extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading:          false,
            MstPRAgencyID:      0,
            // Agency contact
            AgencyName:         '',
            Mobile:             '',
            Designation:        '',
            Telephone:          '',
            Fax:                '',
            Email:              '',
            // Bank details
            BankName:           '',
            BranchName:         '',
            AccountNo:          '',
            BeneficiaryName:    '',
            BeneficiaryAddress: '',
            SwiftCode:          '',
            RTGSIFSCCode:       '',
            PANNo:              '',
            GSTNo:              '',
            // Errors
            AgencyNameErr:      '',
            MobileErr:          '',
            DesignationErr:     '',
            EmailErr:           '',
        };
        this.handleSave    = this.handleSave.bind(this);
        this.onCancel      = this.onCancel.bind(this);
        this.inputValidate = this.inputValidate.bind(this);
    }

    componentDidMount() {
        const locState = this.props.location.state;
        const editData = locState && locState.editData ? locState.editData : null;
        if (editData) {
            this.setState({
                MstPRAgencyID:      editData.PRAgencyID      || 0,
                AgencyName:         editData.AgencyName      || '',
                Mobile:             editData.Mobile          || '',
                Designation:        editData.Designation     || '',
                Telephone:          editData.Telephone       || '',
                Fax:                editData.Fax             || '',
                Email:              editData.Email           || '',
                BankName:           editData.BankName        || '',
                BranchName:         editData.BranchName      || '',
                AccountNo:          editData.AccountNo       || '',
                BeneficiaryName:    editData.BeneficiaryName    || '',
                BeneficiaryAddress: editData.BeneficiaryAddress || '',
                SwiftCode:          editData.SwiftCode       || '',
                RTGSIFSCCode:       editData.RTGSIFSCCode    || '',
                PANNo:              editData.PANNo           || '',
                GSTNo:              editData.GSTNo           || '',
            });
        }
    }

    inputValidate() {
        const { AgencyName, Mobile, Email, Designation } = this.state;
        let valid = true;
        if (!AgencyName) { this.setState({ AgencyNameErr: 'Please Enter Agency Name' }); valid = false; }
        if (!Designation) { this.setState({ DesignationErr: 'Please Enter Designation' }); valid = false; }
        if (!Mobile) { this.setState({ MobileErr: 'Please Enter Mobile No.' }); valid = false; }
        if (!Email) {
            this.setState({ EmailErr: 'Please Enter Email' }); valid = false;
        } else {
            const emailErr = emailValidator(Email);
            if (emailErr) { this.setState({ EmailErr: 'Please Enter Proper Email' }); valid = false; }
        }
        return valid;
    }

    handleSave() {
        if (!this.inputValidate()) {
            toastError('Please fill in all mandatory fields.');
            return;
        }
        const {
            MstPRAgencyID, AgencyName, Mobile, Designation, Telephone, Fax, Email,
            BankName, BranchName, AccountNo, BeneficiaryName, BeneficiaryAddress,
            SwiftCode, RTGSIFSCCode, PANNo, GSTNo,
        } = this.state;

        this.setState({ isLoading: true });
        this.props.insertUpdatePRAgencyMaster_action({
            MstPRAgencyID, AgencyName, Mobile, Designation, Telephone, Fax, Email,
            BankName, BranchName, AccountNo, BeneficiaryName, BeneficiaryAddress,
            SwiftCode, RTGSIFSCCode, PANNo, GSTNo,
        })
            .then((data) => {
                this.setState({ isLoading: false });
                if (data.error != 1) {
                    toastSuccess('Record saved successfully.');
                    setTimeout(() => this.props.navigate('/prAgencyMasterList'), 300);
                } else {
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isLoading: false });
            });
    }

    onCancel() {
        this.props.navigate('/prAgencyMasterList');
    }

    render() {
        const {
            isLoading,
            AgencyName, Mobile, Designation, Telephone, Fax, Email,
            BankName, BranchName, AccountNo, BeneficiaryName, BeneficiaryAddress,
            SwiftCode, RTGSIFSCCode, PANNo, GSTNo,
            AgencyNameErr, MobileErr, DesignationErr, EmailErr,
        } = this.state;

        return (
            <>
                {isLoading && <Loader />}
                <ToastContainer />
                <HeaderWithLogo />

                <div className="app-content with-dr-container com-height">
                    <AdminDrawer />
                    <div className="main-container">

                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">PR Agency Master</h6>
                            </div>
                        </div>

                        <div className="admin-top-space p-2 pt-0">

                            <div className="card-header p-2">
                                <h3 className="card-title" style={{ fontSize: 15 }}>Agency contact</h3>
                            </div>
                            <div className="card-body p-2 mt-1">
                                <div className="row">
                                    <div className="col-xl-4">
                                        <label>Agency Name<span className="text-red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={AgencyName}
                                            onChange={(e) => this.setState({ AgencyName: e.target.value, AgencyNameErr: '' })}
                                        />
                                        <span className="text-danger d-block mt-1">{AgencyNameErr}</span>
                                    </div>
                                    <div className="col-xl-4">
                                        <label>Mobile No.<span className="text-red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Use / to separate multiple numbers"
                                            value={Mobile}
                                            onChange={(e) => this.setState({ Mobile: e.target.value, MobileErr: '' })}
                                        />
                                        <span className="text-danger d-block mt-1">{MobileErr}</span>
                                    </div>
                                    <div className="col-xl-4">
                                        <label>Designation<span className="text-red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={Designation}
                                            onChange={(e) => this.setState({ Designation: e.target.value, DesignationErr: '' })}
                                        />
                                        <span className="text-danger d-block mt-1">{DesignationErr}</span>
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-xl-4">
                                        <label>Telephone</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Use / to separate multiple numbers"
                                            value={Telephone}
                                            onChange={(e) => this.setState({ Telephone: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-4">
                                        <label>Fax</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Use / to separate multiple numbers"
                                            value={Fax}
                                            onChange={(e) => this.setState({ Fax: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-4">
                                        <label>Email<span className="text-red">*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={Email}
                                            onChange={(e) => this.setState({ Email: e.target.value, EmailErr: '' })}
                                        />
                                        <span className="text-danger d-block mt-1">{EmailErr}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="card-header p-2 mt-2">
                                <h3 className="card-title" style={{ fontSize: 15 }}>Bank Details</h3>
                            </div>
                            <div className="card-body p-2 mt-1">
                                <div className="row">
                                    <div className="col-xl-3">
                                        <label>Bank Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={BankName}
                                            onChange={(e) => this.setState({ BankName: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-6">
                                        <label>Bank Branch / Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={BranchName}
                                            onChange={(e) => this.setState({ BranchName: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3">
                                        <label>Account Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={AccountNo}
                                            onChange={(e) => this.setState({ AccountNo: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-xl-3">
                                        <label>Beneficiary Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={BeneficiaryName}
                                            onChange={(e) => this.setState({ BeneficiaryName: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-6">
                                        <label>Beneficiary Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={BeneficiaryAddress}
                                            onChange={(e) => this.setState({ BeneficiaryAddress: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3">
                                        <label>Swift Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={SwiftCode}
                                            onChange={(e) => this.setState({ SwiftCode: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-xl-3">
                                        <label>RTGS / IFSC Code</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={RTGSIFSCCode}
                                            onChange={(e) => this.setState({ RTGSIFSCCode: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3">
                                        <label>PAN Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={PANNo}
                                            onChange={(e) => this.setState({ PANNo: e.target.value })}
                                        />
                                    </div>
                                    <div className="col-xl-3">
                                        <label>GST Number</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={GSTNo}
                                            onChange={(e) => this.setState({ GSTNo: e.target.value })}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="p-2 save-can d-block">
                                <div className="text-end">
                                    <button type="button" className="btn btn-aqua" onClick={this.handleSave}>
                                        Save
                                    </button>
                                    <button type="button" className="btn btn-gray ms-2" onClick={this.onCancel}>
                                        Back
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <Footer />
            </>
        );
    }
}

export default withRouter(
    connect(null, {
        insertUpdatePRAgencyMaster_action,
    })(PRAgencyMasterAU)
);
